import { html, ref, repeat, when } from '@microsoft/fast-element';
import { closeIcon } from '../_common/icons';
import { getPrefix } from '../utils';
export const getDialogTemplate = (prefix) => html `
  <dialog ${ref('mainElement')} part="dialog">
    <div class="content-wrapper">
      <div part="top" class="top">
        <slot name="top">
          <h2 slot="top" class="title">${(x) => { var _a; return (_a = x.notification) === null || _a === void 0 ? void 0 : _a.title; }}</h2>
        </slot>
        ${when((x) => x.showCloseIcon, html `
            <div class="close-icon" @click=${(x) => x.close()}>${closeIcon()}</div>
          `)}
      </div>
      <slot>
        ${when((x) => x.notification, html `
            <div class="details">
              ${(x) => { var _a; return ((_a = x.notification) === null || _a === void 0 ? void 0 : _a.body) || 'Place holder for notification message'; }}
            </div>
          `)}
      </slot>
      <div part="bottom" class="bottom">
        <slot name="bottom">
          ${when((x) => x.notification, html `
          <${prefix}-button appearance="lightweight" @click=${(x) => {
    x.dismiss();
}}>
            ${(x) => { var _a, _b, _c, _d; return ((_d = (_c = (_b = (_a = x.notification) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.dialog) === null || _c === void 0 ? void 0 : _c.dismissingAction) === null || _d === void 0 ? void 0 : _d.label) || 'Ignore'; }}
          </${prefix}-button>
          `)}
          ${repeat((x) => { var _a, _b; return (_b = (_a = x.notification) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.dialog.confirmingActions; }, html `
        <${prefix}-button
          appearance="lightweight"
          @click=${(x, c) => {
    x === null || x === void 0 ? void 0 : x.action();
    c.parent.closeDialog();
}}
        >
          ${(x) => x.label}
        </${prefix}-button>
        `)}
        </slot>
      </div>
    </div>
  </dialog>
`;
export const foundationDialogTemplate = html `
  ${(x) => getDialogTemplate(getPrefix(x))}
`;
